import { useContext } from "react";
import { useTinodeConnection } from "../../../../hooks/useTinodeConnection";
import { GlobalStateContext } from "../../../../components/context/GlobalStateContext";
import { useQuery } from "@tanstack/react-query";
import { getDetailUserProfile } from "../../../../services/profileApi";
import { FaUserCircle } from "react-icons/fa";

const UserInfo = ({ user, userInfo }) => {
  const { isConnected } = useTinodeConnection(user);
  const { isLogin } = useContext(GlobalStateContext);

  const { data, isFetching } = useQuery({
    queryKey: ["detail-user-profile"],
    queryFn: () => getDetailUserProfile(),
    enabled: isLogin === true,
    keepPreviousData: false,
  });

  return (
    <div className="flex flex-col items-center justify-center py-2">
      {data && data.profile_image === "" && !isFetching ? (
        <FaUserCircle className="w-[150px] h-[150px] rounded-full text-gray-300 border-2 border-gray-200" />
      ) : isFetching ? (
        <div className="w-[150px] h-[150px] rounded-full bg-slate-200 border-2 border-gray-200"></div>
      ) : (
        <img
          src={data && data.profile_image}
          alt="Profile IMG"
          className="w-[150px] h-[150px] rounded-full object-cover border-2 border-gray-200"
        />
      )}
      {data && isFetching ? (
        <div className="flex flex-col w-full items-center mt-2 animate-pulse">
          <div className="w-2/3 h-6 bg-slate-200 rounded-lg mb-2"></div>
          <div className="h-4 rounded-md w-1/2 bg-slate-200"></div>
        </div>
      ) : (
        <div className="flex flex-col items-center mt-2">
          <h1 className="font-semibold text-slate-700 text-center leading-tight">
            {data && data.fullname}
          </h1>
          <p className="text-slate-500 font-medium text-md text-center mt-1">
            {data && data.speciality}, SIP {data && data.no_sip}
          </p>
        </div>
      )}
      <div
        className={`${isConnected ? "bg-green-100" : "bg-red-100"} rounded-full py-1 px-2 flex items-center gap-1 mt-4`}
      >
        <div
          className={`w-2 h-2 rounded-full ${isConnected ? "bg-green-600" : "bg-error"}`}
        ></div>
        <p
          className={`text-md font-medium ${isConnected ? "text-green-600" : "text-error"}`}
        >
          {isConnected ? "Online" : "Sedang offline"}
        </p>
      </div>
    </div>
  );
};

export default UserInfo;
